export const UNKNOWN_ERROR_CODE = 'UNKNOWN';
export const REQUEST_FAILED_MESSAGE = 'Request failed';

export interface ErrorParts {
  code: string;
  message: string;
  details?: unknown;
}

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null;
}

/** Reads Go's `{ error: { code, message } }` envelope and the proxied services' `{ error: "message" }`. */
export function errorParts(data: unknown, fallback: string): ErrorParts {
  const error = isRecord(data) ? data.error : undefined;
  if (typeof error === 'string' && error.length > 0) return { code: UNKNOWN_ERROR_CODE, message: error };
  if (!isRecord(error)) return { code: UNKNOWN_ERROR_CODE, message: fallback };
  return {
    code: typeof error.code === 'string' ? error.code : UNKNOWN_ERROR_CODE,
    message: typeof error.message === 'string' ? error.message : fallback,
    details: error.details,
  };
}
